import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { MONTH_NAMES } from './utils';
import RateCardTab from './RateCardTab';
import { Logo, UserChip, MenuLink } from './PageHeader';

export default function RateCardPage({ session, onSignOut }) {
  const [months, setMonths] = useState([]);
  const [selMonth, setSelMonth] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.rpc('rate_card_periods').then(({ data, error: e }) => {
      if (e) setError(e.message);
      else if (data?.length) {
        setMonths(data);
        setSelMonth({ year: data[0].period_year, month: data[0].period_month });
      }
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ maxWidth: 1480, margin: '0 auto', padding: '24px 24px 60px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, flexWrap: 'wrap', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <MenuLink />
          <Logo />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <select
            value={selMonth ? `${selMonth.year}-${selMonth.month}` : ''}
            onChange={e => {
              const [y, m] = e.target.value.split('-').map(Number);
              setSelMonth({ year: y, month: m });
            }}
            style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 14px', color: 'var(--text)', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}
          >
            {months.map(m => (
              <option key={`${m.period_year}-${m.period_month}`} value={`${m.period_year}-${m.period_month}`}>
                {MONTH_NAMES[m.period_month]} {m.period_year}
              </option>
            ))}
          </select>
          <UserChip session={session} onSignOut={onSignOut} />
        </div>
      </header>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Rate Card vs COR</h2>

      {loading && <div style={{ padding: 60, textAlign: 'center', color: 'var(--text3)' }}>Cargando…</div>}
      {error && <div style={{ padding: 60, textAlign: 'center', color: 'var(--red)' }}>No se pudo cargar: {error}</div>}
      {!loading && !error && selMonth && <RateCardTab selMonth={selMonth} />}
    </div>
  );
}
